import { Tab, TabList, Tabs } from '@chakra-ui/react'

interface CustomTagsProps {
  choices: string[]
  results: string[]
  value: string
  onChange: (v: string) => void
}

const CustomTabsMultiple = ({ value, onChange, choices, results }: CustomTagsProps) => {
  const selectedTabs: string[] = value.split(',').filter((item) => item !== '')

  const handleTabClick = (index: number) => {
    if (selectedTabs.includes(results[index])) {
      const newSelectedTabs: string[] = selectedTabs.filter(
        (selectedTab: string) => selectedTab !== results[index],
      )
      onChange(newSelectedTabs.join(','))
    } else {
      const newSelectedTabs: string[] = [...selectedTabs, results[index]]
      onChange(newSelectedTabs.join(','))
    }
  }

  return (
    <Tabs size="sm" variant="unstyled">
      <TabList flexWrap="wrap" gap="6px">
        {choices.map((v: string, i: number) => {
          const isSelected = selectedTabs.includes(results[i])

          return (
            <Tab
              key={i}
              fontSize="13px"
              fontWeight="400"
              lineHeight="20px"
              bg={isSelected ? '#171C22' : 'transparent'}
              color={isSelected ? 'white' : '#171C22'}
              borderRadius="70px"
              padding="10px 14px"
              _active={{ bg: '#171C22' }}
              border={isSelected ? '0.5px solid #171C22' : '0.5px solid #DCE2EA'}
              onClick={() => handleTabClick(i)}
            >
              {v}
            </Tab>
          )
        })}
      </TabList>
    </Tabs>
  )
}

export default CustomTabsMultiple